import { connect } from 'react-redux';
import { FloatingTubeRack as Component } from './FloatingTubeRack';
import {
  pushInteractions,
  waterBathContainsTubeRack,
  tubeInWaterBath,
  tubeInFreezer,
  freezerContainsTubeRack,
  setFloatingTubeRackHeld,
  setFloatingTubeRackControlVisibility,
  hideAllControls,
  showMoveMenu,
  setMoveMenu,
  createFloatingTubeRack,
  setModal,
  showModal,
  setHeldObject,
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  if (state.notebook.protocolSection.scene.apparatus.hasOwnProperty("floatingTubeRack") &&
    state.notebook.protocolSection.scene.apparatus.floatingTubeRack.some(
      floatingTubeRack => floatingTubeRack.id === ownProps.id
    )
  ) {
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.floatingTubeRack[ownProps.id -1].type,
      inWaterBath: state.notebook.protocolSection.scene.apparatus.floatingTubeRack[ownProps.id-1].inWaterBath,
      waterBathOpen: state.notebook.protocolSection.scene.apparatus.waterBath[ownProps.id-1].open,
      waterBathHasTubeRack: state.notebook.protocolSection.scene.apparatus.waterBath[ownProps.id-1].containsTubeRack,
      tubes: state.notebook.protocolSection.scene.apparatus.floatingTubeRack[ownProps.id-1].tubes,
      controlsVisible: state.notebook.protocolSection.scene.apparatus.floatingTubeRack[ownProps.id-1].controlsVisible,
      interactionProps: {
        waterBath: state.notebook.protocolSection.scene.apparatus.waterBath,
      },
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {

    pushInteractions: (data) =>{
      dispatch(pushInteractions(data))
    },
    waterBathContainsTubeRack: (data) =>{
      dispatch(waterBathContainsTubeRack(data))
    },
    tubeInWaterBath: (data) =>{
      dispatch(tubeInWaterBath(data))
    },
    tubeInFreezer: (data) =>{
      dispatch(tubeInFreezer(data))
    },
    freezerContainsTubeRack: (data) =>{
      dispatch(freezerContainsTubeRack(data))
    },
    setFloatingTubeRackHeld: (data) =>{
      dispatch(setFloatingTubeRackHeld(data))
    },
    setFloatingTubeRackControlVisibility: (data) =>{
      dispatch(setFloatingTubeRackControlVisibility(data))
    },
    hideAllControls: (data) =>{
      dispatch(hideAllControls(data))
    },
    showMoveMenu: (data) =>{
      dispatch(showMoveMenu(data))
    },
    setMoveMenu: (data) =>{
      dispatch(setMoveMenu(data))
    },
    createFloatingTubeRack: (data) =>{
      dispatch(createFloatingTubeRack(data))
    },

    setModal: (data) => {
      dispatch(    setModal(data))
    },

    showModal: (data) => {
      dispatch(    showModal(data))
    },
    setHeldObject: (data) => {
      dispatch(    setHeldObject(data))
    },
    

  };
}

export const FloatingTubeRack = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
